import React from "react";
let resolution = window.RESOLUTION;

const LoaderScreen = ({ disply, screen }) => {
  console.log("LoaderScreen", disply, screen);
  return (
    <div
      style={{
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        backgroundColor: screen == "SearchPage" ? "rgba(0, 0, 0, 0.4)": screen == "" ? "#000037" : "#000037",
        zIndex: "999",
      }}
    >
      <div
        className="loader"
        style={{
          position: "relative",
          width: resolution === "FHD" ? "80px" : "60px",
          height: resolution === "FHD" ? "80px" : "60px",
        }}
      ></div>
    </div>
  );
};
export default LoaderScreen;
